import React from 'react';

// Dynamic registry loader: attempts to resolve normalized SVGs via webpack require.context
let ICON_REGISTRY = {};
try{

  ICON_REGISTRY = require('../iconRegistry').ICON_MAP || {};
}catch { ICON_REGISTRY = {}; }

let iconsContext = null;
try{
  // webpack-specific API - safe-guarded for test environments

  iconsContext = require.context('../icons/normalized', true, /\.svg$/);
}catch { iconsContext = null; }

export default function Icon({ name, size = 16, className = '', title = '' }) {
  const common = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className };

  switch (String(name || '').toLowerCase()) {
    case 'trash':
      return (
        <svg {...common} aria-hidden={title ? 'false' : 'true'} role={title ? 'img' : 'presentation'}>
          {title ? <title>{title}</title> : null}
          <path d="M3 6h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'plus':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'lock':
      return (
        <svg {...common} aria-hidden>
          <rect x="3" y="11" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path d="M7 11V8a5 5 0 0 1 10 0v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'bell':
      return (
        <svg {...common} aria-hidden>
          <path d="M15 17H9a3 3 0 0 1-3-3v-3a6 6 0 1 1 12 0v3a3 3 0 0 1-3 3z" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'check':
      return (
        <svg {...common} aria-hidden>
          <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </svg>
      );
    case 'folder':
      return (
        <svg {...common} aria-hidden>
          <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'tools':
      return (
        <svg {...common} aria-hidden>
          <path d="M14.7 9.3l-1.4 1.4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 14l6-6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 21l6-6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'shield':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 3l7 4v5c0 5-4 9-7 10-3-1-7-5-7-10V7l7-4z" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'users':
      return (
        <svg {...common} aria-hidden>
          <path d="M17 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.3" fill="none"/>
        </svg>
      );
    case 'location':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="9" r="2" fill="currentColor"/>
        </svg>
      );
    case 'bolt':
      return (
        <svg {...common} aria-hidden>
          <path d="M13.2 2.5L5.5 13h5.2l-.9 8.5L18.5 11h-5.1l-.2-8.5z" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinejoin="round" />
        </svg>
      );
    case 'globe':
      return (
        <svg {...common} aria-hidden>
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.2" fill="none"/>
          <path d="M2 12h20M12 2v20" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'docs':
      return (
        <svg {...common} aria-hidden>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'brain':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 3c-2 0-4 1-5 3-1 2-1 4 0 6 1 2 3 3 5 3s4-1 5-3c1-2 1-4 0-6-1-2-3-3-5-3z" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'robot':
      return (
        <svg {...common} aria-hidden>
          <rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="1.3" fill="none"/>
          <path d="M7 4h10v3H7z" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="9" cy="12" r="1" fill="currentColor"/>
          <circle cx="15" cy="12" r="1" fill="currentColor"/>
        </svg>
      );
    case 'close':
      return (
        <svg {...common} aria-hidden>
          <path d="M6 6 L18 18 M6 18 L18 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'clipboard':
      return (
        <svg {...common} aria-hidden>
          <path d="M9 2h6a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2H9A2 2 0 0 1 7 4V4a2 2 0 0 1 2-2z" stroke="currentColor" strokeWidth="1.3" fill="none"/>
          <rect x="3" y="6" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.3" fill="none"/>
        </svg>
      );
    case 'image':
      return (
        <svg {...common} aria-hidden>
          <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.3" />
          <circle cx="8" cy="9" r="1.5" fill="currentColor" />
          <path d="M4 17l5-5 3 3 2-2 6 6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'warning':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 3l9 17H3L12 3z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
          <path d="M12 9v4M12 16h.01" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      );
    case 'download':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 3v12M7 10l5 5 5-5M4 20h16" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'target':
      return (
        <svg {...common} aria-hidden>
          <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.3" />
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.3" />
        </svg>
      );
    case 'lightbulb':
      return (
        <svg {...common} aria-hidden>
          <path d="M8 15h8M9 18h6M10 21h4M8 13a6 6 0 1 1 8 0c-1 1-1 2-1 2H9s0-1-1-2z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'sparkles':
      return (
        <svg {...common} aria-hidden>
          <path d="M12 3l1.4 4.6L18 9l-4.6 1.4L12 15l-1.4-4.6L6 9l4.6-1.4L12 3zM19 15l.6 2.4L22 18l-2.4.6L19 21l-.6-2.4L16 18l2.4-.6L19 15z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
        </svg>
      );
    default:
      break;
  }
  // Dynamic registry resolution fallback (renders normalized SVGs from src/icons/normalized)
  try{
    const key = String(name||'').toLowerCase();
    if(ICON_REGISTRY && ICON_REGISTRY[key] && iconsContext){
      const rel = iconRegistryContextKey(ICON_REGISTRY[key]);
      if (!rel) throw new Error('Invalid icon registry path');
      try{
        const mod = iconsContext(rel);
        const src = (mod && (mod.default || mod));
        if(src){
          return <img src={src} width={size} height={size} className={className} alt={title || key} />;
        }
      }catch { /* fallthrough to generic fallback below */ }
    }
  }catch { /* ignore */ }

  // Generic fallback: simple circle (keeps visual stability when unknown)
  return (
    <svg {...common} aria-hidden>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.3" fill="none"/>
    </svg>
  );
}

export function iconRegistryContextKey(path) {
  const relativePath = String(path || '')
    .replace(/\\/g, '/')
    .replace(/^\.\/icons\/normalized\/?/, '')
    .replace(/^\/+/, '');
  return relativePath ? `./${relativePath}` : '';
}
